export const randomizeArr = (arr) => {
    return arr.sort(function() {
        return Math.random() > 0.5? -1 : 1
    })
};

export const generateArr = (size) => {

    const targetArr = [];

    for(let i = 0; i < size; i++) {
        targetArr.push(i);
    }

    return targetArr;
};